"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const shallow_1 = require("zustand/shallow");
const useAdjustWeightModal_1 = require("hooks/useAdjustWeightModal/useAdjustWeightModal");
const HelperUtils_1 = require("utils/HelperUtils");
const TextArea_1 = __importDefault(require("components/shared/TextArea"));
const CommentUpdate = () => {
    const { handleChangeComment, commentValue } = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => ({
        handleChangeComment: state.handleChangeComment,
        commentValue: state.payloadBody.comment
    }), shallow_1.shallow);
    const onInputChange = (e) => {
        handleChangeComment(e.target.value);
    };
    return (react_1.default.createElement("div", { className: "px-[24px] w-full" },
        react_1.default.createElement("p", { className: "text-n-900 typography-h100 mb-[8px]" }, (0, HelperUtils_1.getObjectiveLocale)('Comment')),
        react_1.default.createElement(TextArea_1.default, { onHandleChange: onInputChange, textPlaceholder: (0, HelperUtils_1.getObjectiveLocale)('Tell the reason why you update this progress...'), value: commentValue || '', className: "content-comment h-[60px]", dataCy: "adjust-comment", height: 120, maxHeight: 120, autoFocus: true })));
};
exports.default = CommentUpdate;
